import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
    FETCH_ALL_PATIENT,
    UPDATE_PATIENT,
    CREATE_PATIENT,
    DELETE_PATIENT,
} from 'constants/patients.constants'
import {
    fetchPatientsSuccess,
    updatePatientSuccess,
    createPatientSuccess,
    deletePatientSuccess,
} from "actions/patients.action";
import { showErrors, stopLoader } from "actions/general.action";
import { authinstance } from "sagas";
import qs from 'qs'


// patient sagas

const fetchPatientsRequest = async (page) => {
    return authinstance.get('api/v1/super_admin/users/index?page=' + page + '&roles=6');
}

function* fetchPatients({ payload }) {
    try {
        const reuslt = yield call(fetchPatientsRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(fetchPatientsSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}

const updatePatientsRequest = async (payload) => {
    let o = Object.assign({}, payload);
    
    return authinstance({
        method: 'put',
        url: 'api/v1/super_admin/users/' + payload.id,
        data: qs.stringify(o)
      })
}

function* updatePatient({ payload }) {
    try {
        const reuslt = yield call(updatePatientsRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(updatePatientSuccess(reuslt.data));
            yield put(stopLoader("Patient updated"))
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}

const createPatientsRequest = async (payload) => {
    let o = Object.assign({}, payload);
    o.role_ids = 6
    //o.call_back_url = process.env.REACT_APP_FRONT_END_HOST + 'setpassword'

    return authinstance({
        method: 'post',
        url: 'api/v1/super_admin/patients',
        data: qs.stringify(o)
      })
}

function* createPatient({ payload }) {
    try {
        const reuslt = yield call(createPatientsRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield all([
                put(createPatientSuccess(reuslt.data)),
                //put(stopLoader("Patient created"))
            ])
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}

const deletePatientsRequest = async (id) => {
    return authinstance({
        method: "delete",
        url: '/api/v1/super_admin/users/' + id + '?role=6',
        headers: {
          'Content-Type': 'text/plain'
        },
        data: "",
    });

}

function* deletePatient({ payload }) {
    try {
        const reuslt = yield call(deletePatientsRequest, payload);
        if (!reuslt.status) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(deletePatientSuccess(payload));
            yield put(stopLoader("Patient deleted"))
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}

// fork patient
export function* forkFetchPatients() {
    yield takeEvery(FETCH_ALL_PATIENT, fetchPatients);
}

export function* forkUpdatePatient() {
    yield takeEvery(UPDATE_PATIENT, updatePatient);
}

export function* forkCreatePatient() {
    yield takeEvery(CREATE_PATIENT, createPatient);
}

export function* forkDeletePatient() {
    yield takeEvery(DELETE_PATIENT, deletePatient);
}

export default function* rootSaga() {
    yield all([
        fork(forkFetchPatients),
        fork(forkUpdatePatient),
        fork(forkCreatePatient),
        fork(forkDeletePatient),
    ]);
}